export const TEST_ID = 'arrowRightIcon';
